export default class FeTerm {
    /**
     * @type {string}
     * @memberof FeTerm
     * @name 学期Id
     */
    public termId: string;
    /**
     * @type {string}
     * @memberof FeTerm
     * @name 学期编号
     */
    public no: string;
    /**
     * @type {string}
     * @memberof FeTerm
     * @name 学期名字
     */
    public name: string;
    /**
     * @type {string}
     * @memberof FeTerm
     * @name 所属年份
     */
    public year: string;
    /**
     * @type {string}
     * @memberof FeTerm
     * @name 开始日期 yyyy-MM-dd
     */
    public startDate: string;
    /**
     * @type {string}
     * @memberof FeTerm
     * @name 结束日期 yyyy-MM-dd
     */
    public endDate: string;
    /**
     * @type {boolean}
     * @memberof FeTerm
     * @name 当前学期
     */
    public currentFlag: boolean;
    constructor({
        termId = '',
        no = '',
        name = '',
        year = '',
        startDate = '',
        endDate = '',
        currentFlag = false
    } = {}) {
        this.termId = termId,
        this.no = no,
        this.name = name,
        this.year = year,
        this.startDate = startDate,
        this.endDate = endDate,
        this.currentFlag = currentFlag
    }
}